import { Component, OnInit } from '@angular/core';
import { SubscriptionRequest } from "../../models/SubscriptionRequest"
import { SubscriptionEvent } from "../../models/SubscriptionEvent"
import { environment } from '../../../environments/environment';

import { FormGroup, FormControl } from '@angular/forms';
import { IsoeventsubscriptionmangementserviceService } from '../../services/isoeventsubscriptionmangementservice.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-subscribeevents',
  templateUrl: './subscribeevents.component.html',
  styleUrls: ['./subscribeevents.component.css']
})
export class SubscribeeventsComponent implements OnInit {

  constructor(private eventService: IsoeventsubscriptionmangementserviceService,
    private titleService:Title) { }

  isoEvents: SubscriptionEvent[] = [];

  model = new SubscriptionRequest();
  selectedEvents = null;
  submitted: boolean = false;
  requestProcessed: boolean = false;
  messageToDisplay: string = "";
  requestFailed: boolean = false;
  dataLoaded: boolean = false;
  sourceId = "";
  isOrgNameMandatory = false;
  noIsoEmail = false;
  caisoEmailNotAllowed = false;
  pageHeading:string ="Subscribe to email notifications";

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle(this.pageHeading);
    this.noIsoEmail = environment.noIsoEmail;

    await this.eventService.getEventDetails().then(data => {
      this.isoEvents = data
      this.sourceId = environment.sourceId;
      this.isOrgNameMandatory = environment.isOrgNameMandatory; 

      if (!this.model.eventNames) {
        this.model.eventNames = [];
      }

      if (this.isoEvents) {
        this.dataLoaded = true;
        if (this.isoEvents.length == 1) {
          this.model.eventNames.push(this.isoEvents[0].eventName);
          this.pageHeading ="Subscribe to "+this.isoEvents[0].eventName;
        }
      }
      else {
        this.messageToDisplay = "Failed to get the events";
        this.requestFailed = true;
      }

    });;
  }

 
 onEmailChange(emailValue: string): void {   
  this.caisoEmailNotAllowed = false;
  if (this.noIsoEmail 
    && emailValue.toLowerCase().indexOf('@caiso.com')>0) {
    this.caisoEmailNotAllowed = true; 
  }
}

  submit(subscriptionForm) {
    console.log('Form submitted', subscriptionForm);
    this.caisoEmailNotAllowed = false;
    if (subscriptionForm.form.status == 'INVALID') {
      this.showValidationMsg(subscriptionForm);
      return;
    }
    //if there is no validation errors
    else {

      if (this.noIsoEmail 
        && this.model.emailAddress.toLowerCase().indexOf('@caiso.com')>0) {
        this.caisoEmailNotAllowed = true;
        return;
      }
      else {
        this.eventService.SubscribeToEvents(this.model).subscribe(
          result => {
            // Handle result
            this.requestProcessed = true;
            this.messageToDisplay =  "'"+ this.model.emailAddress+"' has been successfully subscribed.";
          },
          error => {
            console.log(error)
            this.requestProcessed = true;
            this.messageToDisplay = "Failed to process the request";
            this.requestFailed = true;
          }
        );
      }
    }
  }

  ////Method to add the event name to the selected list
  onEventSelectionChange(e: any) {

    if (!this.model.eventNames) {
      this.model.eventNames = [];
    }

    if (e.currentTarget.checked) {
      this.model.eventNames.push(e.currentTarget.value);
    }
    else {
      this.model.eventNames = this.model.eventNames.filter(eventName => eventName != e.currentTarget.value)
    }
    this.selectedEvents = this.model.eventNames.join();
  }


  ////Method to show validation on button submit click
  showValidationMsg(formGroup: FormGroup) {
    for (const key in formGroup.controls) {

      if (formGroup.controls.hasOwnProperty(key)) {
        const control: FormControl = <FormControl>formGroup.controls[key];

        if (Object.keys(control).includes('controls')) {
          const formGroupChild: FormGroup = <FormGroup>formGroup.controls[key];
          this.showValidationMsg(formGroupChild);
        }

        control.markAsTouched();
      }
    }
  }
}
